import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { assessmentsRoutes } from './features/assessments/routes';
import { authRoutes } from './features/auth/routes';
import { climateScenariosRoutes } from './features/climate-scenarios/routes';
import { climateVariablesRoutes } from './features/climate-variables/routes';
import { evaluationsRoutes } from './features/evaluations/routes';
import { essentialsRoutes } from './features/essentials/routes';
import { hazardFamiliesRoutes } from './features/hazard-families/routes';
import { hazardFamilyClimateVariablesRoutes } from './features/hazard-family-climate-variables/routes';
import { hazardBaselineRoutes } from './features/hazard-baseline/routes';
import { hazardCatalogRoutes } from './features/hazard-catalog/routes';
import { hazardsRoutes } from './features/hazards/routes';
import { impersonationRoutes } from './features/impersonation/routes';
import { localNationalClimateReferencesRoutes } from './features/local-national-climate-references/routes';
import { questionsRoutes } from './features/questions/routes';
import { regionalClimateReferencesRoutes } from './features/regional-climate-references/routes';
import { profileRoutes } from './features/profile/routes';
import { rolesRoutes } from './features/roles/routes';
import { usersRoutes } from './features/users/routes';
import { vulnerabilityIndicatorsRoutes } from './features/vulnerability-indicators/routes';

export const routes: Routes = [
  {
    path: APP_ROUTES.AUTH,
    loadComponent: () => import('./layouts/auth-layout').then((m) => m.AuthLayout),
    children: [...authRoutes],
  },
  {
    // Must precede the empty-path AuthLayout route below: with pathMatch 'full' it
    // only claims the exact root URL, so `/` redirects to home instead of being
    // swallowed by the prefix-matching layout route (which would leave a blank page).
    path: APP_ROUTES.ROOT,
    redirectTo: APP_ROUTES.HOME,
    pathMatch: 'full',
  },
  {
    // Root-relative so it matches the links emailed by the backend (cr.med.gov.sy/set-password, .../reset-password)
    path: APP_ROUTES.ROOT,
    loadComponent: () => import('./layouts/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        title: 'pagesTitles.setPassword',
        path: APP_ROUTES.SET_PASSWORD,
        loadComponent: () =>
          import('./features/auth/pages/set-password').then((m) => m.SetPassword),
      },
      {
        title: 'pagesTitles.resetPassword',
        path: APP_ROUTES.RESET_PASSWORD,
        loadComponent: () =>
          import('./features/auth/pages/reset-password').then((m) => m.ResetPassword),
      },
    ],
  },
  {
    path: APP_ROUTES.ROOT,
    canMatch: [authGuard],
    loadComponent: () => import('./layouts/dashboard-layout').then((m) => m.DashboardLayout),
    children: [
      {
        title: 'pagesTitles.home',
        path: APP_ROUTES.HOME,
        loadComponent: () => import('./features/home').then((m) => m.Home),
      },
      ...profileRoutes,
      ...impersonationRoutes,
      ...usersRoutes,
      ...rolesRoutes,
      ...essentialsRoutes,
      ...assessmentsRoutes,
      ...evaluationsRoutes,
      ...questionsRoutes,
      ...hazardFamiliesRoutes,
      ...hazardsRoutes,
      ...hazardCatalogRoutes,
      ...hazardBaselineRoutes,
      ...regionalClimateReferencesRoutes,
      ...climateVariablesRoutes,
      ...hazardFamilyClimateVariablesRoutes,
      ...climateScenariosRoutes,
      ...localNationalClimateReferencesRoutes,
      ...vulnerabilityIndicatorsRoutes,
    ],
  },
  {
    title: 'pagesTitles.pageNotFound',
    path: '**',
    loadComponent: () =>
      import('./features/page-not-found/page-not-found').then((m) => m.PageNotFound),
  },
];
